module.exports = __webpack_public_path__ + "static/media/obrero.83c24ccf.webp";